import api, { buildQueryParams, normalizeList } from './api';
import axios from 'axios';
import { API_URL } from '../config';

// Users
export const getUsers = async (params = {}) => {
    try {
        const queryString = buildQueryParams(params);
        const url = queryString ? `/api/users/users/?${queryString}` : '/api/users/users/';
        const response = await api.get(url);
        return response.data; // This returns the full paginated object for usePagination
    } catch (error) {
        console.error('Error in getUsers:', error);
        if (error.response) {
            console.error('Error response:', error.response.data);
        } else if (error.request) {
            console.error('No response received:', error.request);
        } else {
            console.error('Error setting up request:', error.message);
        }
        throw error;
    }
};

export const getUsersByRole = async (role) => {
    try {
        let url;
        if (role === 'Technician') {
            url = '/api/users/users/technicians/';
        } else if (role) {
            url = `/api/users/users/?role=${encodeURIComponent(role)}`;
        } else {
            url = '/api/users/users/';
        }
        const response = await api.get(url);
        return normalizeList(response.data);
    } catch (error) {
        console.error('Error in getUsersByRole:', error);
        if (error.response) {
            console.error('Error response:', error.response.data);
        } else if (error.request) {
            console.error('No response received:', error.request);
        } else {
            console.error('Error setting up request:', error.message);
        }
        return [];
    }
};

export const getUser = async (id) => {
    try {
        const response = await api.get(`/api/users/users/${id}/`);
        return response.data;
    } catch (error) {
        console.error('Error in getUser:', error);
        if (error.response) {
            console.error('Error response:', error.response.data);
        } else if (error.request) {
            console.error('No response received:', error.request);
        } else {
            console.error('Error setting up request:', error.message);
        }
        throw error;
    }
};

export const createUser = async (data) => {
    try {
        const response = await api.post('/api/users/users/', data);
        return response.data;
    } catch (error) {
        console.error('Error in createUser:', error);
        if (error.response) {
            console.error('Error response:', error.response.data);
        } else if (error.request) {
            console.error('No response received:', error.request);
        } else {
            console.error('Error setting up request:', error.message);
        }
        throw error;
    }
};

export const updateUser = async (id, data) => {
    try {
        const response = await api.put(`/api/users/users/${id}/`, data);
        return response.data;
    } catch (error) {
        console.error('Error in updateUser:', error);
        if (error.response) {
            console.error('Error response:', error.response.data);
        } else if (error.request) {
            console.error('No response received:', error.request);
        } else {
            console.error('Error setting up request:', error.message);
        }
        throw error;
    }
};

export const deleteUser = async (id) => {
    try {
        await api.delete(`/api/users/users/${id}/`);
    } catch (error) {
        console.error('Error in deleteUser:', error);
        if (error.response) {
            console.error('Error response:', error.response.data);
        } else if (error.request) {
            console.error('No response received:', error.request);
        } else {
            console.error('Error setting up request:', error.message);
        }
        throw error;
    }
};

// User Actions
export const getCurrentUser = async () => {
    try {
        const response = await api.get('/api/users/users/me/');
        return response.data;
    } catch (error) {
        console.error('❌ Error in getCurrentUser:', error);
        if (error.response) {
            console.error('Error response:', error.response.data);
        } else if (error.request) {
            console.error('No response received:', error.request);
        } else {
            console.error('Error setting up request:', error.message);
        }
        throw error;
    }
};

// Roles
export const getRoles = async () => {
    try {
        const response = await api.get('/api/users/roles/');
        return normalizeList(response.data);
    } catch (error) {
        console.error('Error in getRoles:', error);
        if (error.response) {
            console.error('Error response:', error.response.data);
        } else if (error.request) {
            console.error('No response received:', error.request);
        } else {
            console.error('Error setting up request:', error.message);
        }
        return [];
    }
};

export const getRole = async (id) => {
    try {
        const response = await api.get(`/api/users/roles/${id}/`);
        return response.data;
    } catch (error) {
        console.error('Error in getRole:', error);
        if (error.response) {
            console.error('Error response:', error.response.data);
        } else if (error.request) {
            console.error('No response received:', error.request);
        } else {
            console.error('Error setting up request:', error.message);
        }
        throw error;
    }
};

export const createRole = async (data) => {
    try {
        const response = await api.post('/api/users/roles/', data);
        return response.data;
    } catch (error) {
        console.error('Error in createRole:', error);
        if (error.response) {
            console.error('Error response:', error.response.data);
        } else if (error.request) {
            console.error('No response received:', error.request);
        } else {
            console.error('Error setting up request:', error.message);
        }
        throw error;
    }
};

export const updateRole = async (id, data) => {
    try {
        const response = await api.put(`/api/users/roles/${id}/`, data);
        return response.data;
    } catch (error) {
        console.error('Error in updateRole:', error);
        if (error.response) {
            console.error('Error response:', error.response.data);
        } else if (error.request) {
            console.error('No response received:', error.request);
        } else {
            console.error('Error setting up request:', error.message);
        }
        throw error;
    }
};

export const deleteRole = async (id) => {
    try {
        await api.delete(`/api/users/roles/${id}/`);
    } catch (error) {
        console.error('Error in deleteRole:', error);
        if (error.response) {
            console.error('Error response:', error.response.data);
        } else if (error.request) {
            console.error('No response received:', error.request);
        } else {
            console.error('Error setting up request:', error.message);
        }
        throw error;
    }
};

export const updateUserStatus = async (id, isActive) => {
    try {
        const response = await api.patch(`/api/users/users/${id}/update_status/`, { is_active: isActive });
        return response.data;
    } catch (error) {
        console.error('Error in updateUserStatus:', error);
        if (error.response) {
            console.error('Error response:', error.response.data);
        } else if (error.request) {
            console.error('No response received:', error.request);
        } else {
            console.error('Error setting up request:', error.message);
        }
        throw error;
    }
};

export const getUserProfile = async () => {
    try {
        const response = await api.get('/api/users/users/my_profile/');
        return response.data;
    } catch (error) {
        console.error('Error fetching user profile:', error);
        throw error;
    }
};

export const updateUserProfile = async (data) => {
    try {
        const response = await api.patch('/api/users/users/update_my_profile/', data);
        return response.data;
    } catch (error) {
        console.error('Error updating user profile:', error);
        throw error;
    }
};

export const updateUserBasicInfo = async (data) => {
    try {
        const response = await api.patch('/api/users/users/update_my_basic_info/', data);
        return response.data;
    } catch (error) {
        console.error('Error updating user basic info:', error);
        throw error;
    }
};

export const resetUserPassword = async (userId, newPassword, token) => {
    try {
        const response = await axios.post(
            `${API_URL}/api/users/users/${userId}/reset-password/`,
            { password: newPassword },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error('Error resetting user password:', error.response || error);
        throw error;
    }
};

// Change password for current user (requires old password)
export const changePassword = async (oldPassword, newPassword) => {
    try {
        // First get current user to get their ID
        const currentUser = await getCurrentUser();
        const response = await api.post(`/api/users/users/${currentUser.id}/change_password/`, {
            old_password: oldPassword,
            new_password: newPassword
        });
        return response.data;
    } catch (error) {
        console.error('Error changing password:', error);
        throw error;
    }
}; 